import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import flowRight from 'lodash/flowRight'

import { ErrorView, Loading } from '@fielded/shared-ui'

import { withApi } from '../../../../../common/ApiProvider'
import { withUser } from '../../../../../common/AuthenticationProvider'
import withConfig from '../../../../../van-shared/hoc/withConfig'
import withMasterData from '../../../common/withMasterData'
import withShipment from '../../../common/WithShipmentWrapper'
import { loadPickList } from '../../../../../root/reducers/shipments/pick-list'
import { selectProducts } from '../../../../../root/reducers/shipments/master-data'
import { useAmplitudeAnalytics } from '../../../../../common/analytics-tracking/AmplitudeAnalyticsProvider'
import useShipmentDetails from '../hooks/useShipmentDetails'
import PSMInboundShipmentDetails from './PSMInboundShipmentDetails'

const PSMInboundShipmentDetailsContainer = ({
  api,
  user,
  config,
  history,
  shipment
}) => {
  const dispatch = useDispatch()
  const productsFromStore = useSelector(selectProducts)
  const trackingHandler = useAmplitudeAnalytics()

  useEffect(() => {
    dispatch(loadPickList(shipment, productsFromStore, user))
  }, [shipment, productsFromStore])

  const { productsMap, loading, error } = useShipmentDetails({
    api, user, shipment, trackingHandler
  })

  if (error) {
    return <ErrorView title='Shipment' error={error} />
  }

  if (loading) {
    return <Loading />
  }

  return (
    <PSMInboundShipmentDetails
      config={config}
      history={history}
      shipment={shipment}
      productsMap={productsMap}
    />
  )
}

const withHOCs = flowRight(
  withApi,
  withUser,
  withConfig,
  withMasterData,
  withShipment
)

export default withHOCs(PSMInboundShipmentDetailsContainer)
